<app-change-request-table
  [dataSource]="rows"
  [displayedColumns]="displayedColumns"
  [enableSort]="true"
  enableNavigation
  (sortChange)="sortData($event)"
>
</app-change-request-table>
